import ToolKvSection from './message_tool_kv_section';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var script = {
  name: 'MessageToolDetails',
  components: {
    ToolKvSection
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    isExpanded: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    toolInfo() {
      var _this$message;
      return ((_this$message = this.message) === null || _this$message === void 0 ? void 0 : _this$message.tool_info) || {};
    }
  },
  methods: {
    onCopyCodeSnippet(e) {
      /**
       * Emit copy-code-snippet event that clients can use to interact with a suggested code.
       * @param {*} event An event containing code string in the "detail.code" field.
       */
      this.$emit('copy-code-snippet', e);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-mt-4 gl-grid gl-gap-3"},[(_vm.toolInfo.args)?_c('tool-kv-section',{attrs:{"title":"Request","value":_vm.toolInfo.args},on:{"copy-code-snippet":_vm.onCopyCodeSnippet}}):_vm._e(),_vm._v(" "),(_vm.toolInfo.tool_response)?_c('tool-kv-section',{attrs:{"title":"Response","value":_vm.toolInfo.tool_response},on:{"copy-code-snippet":_vm.onCopyCodeSnippet}}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
